import type { ISingleAccessEmailInviteBody } from '@/app-package';
import axios from 'axios';

const sendSingleAccessEmailInvite = async (
  body: ISingleAccessEmailInviteBody,
): Promise<void> => {
  await axios.post(`/supra/single_access/email_invite`, body);
};

export default sendSingleAccessEmailInvite;
